module.exports = __webpack_public_path__ + "static/media/Logo.593bb05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo.png
// module id = 20
// module chunks = 1